export default __webpack_public_path__ + "static/media/example4.aee804a4.gif";